jQuery(document).ready(function (e){ 

    $(document ).ready(function() {
        const myCustomSlider = document.querySelectorAll('.homecollection_sliders');
        for (i = 0; i < myCustomSlider.length; i++) {
            myCustomSlider[i].classList.add('homecollection_sliders-' + i);
            var swiper = new Swiper('.homecollection_sliders-'+i+' .swiper-container', {
                slidesPerView:5.2,
                initialSlide: 0,
                loop:true,
                lazy:true,
                preloadImages:false,
                observer:true,
                observeParents:true,
                speed: 800,
                freeMode: true,
                freeModeSticky: false,
                mousewheel: {
                    enabled: true,
                    releaseOnEdges: true,
                    forceToAxis: true,
                    sensitivity:1, 
                },
                keyboard: {
                    enabled: true,
                },
                spaceBetween:20,
                navigation: {
                    nextEl: '.homecollection_sliders-'+i+' .swiper-button-next',
                    prevEl: '.homecollection_sliders-'+i+' .swiper-button-prev',
                },
                breakpoints: {
                    320: {
                        slidesPerView:2.1,
                        spaceBetween:8,
                    },
                    600:{
                        slidesPerView:2.1,
                        spaceBetween:8,
                    },
                    780: {
                        slidesPerView:3.2,
                        spaceBetween:20,
                    },
                    1300: {
                        slidesPerView:4.2,
                        spaceBetween:20
                    },
                    1920: {
                        slidesPerView:5.2,
                        spaceBetween:20
                    }
                }
            });
        }
    });     

    window.addEventListener("load", function () {
      document.querySelector('.homemerchandising_sec')?.classList.add('loaded');
    });
    window.addEventListener("load", function () {
        var swiper = new Swiper('.homemerchandising_slider .swiper-container', {
            loop:true,  
            lazy: true,
            preloadImages: false,  
            slidesPerView:2.3,
            spaceBetween:20,
            observer: true,
            observeParents: true,
            speed: 800,
            freeMode: true,
            freeModeSticky: false,
            mousewheel: {
              enabled: true,
              releaseOnEdges: true,
              forceToAxis: true,
              sensitivity:1, 
            },
            keyboard: {
              enabled: true,
            },
            pagination: {
              el: ".homemerchandising_slider .swiper-pagination",
              clickable: true,
            },
            breakpoints: {
                320: {
                  slidesPerView:1.2,
                  spaceBetween:10,
                },
                600:{
                  slidesPerView:1.2,
                  spaceBetween:20,
                },
                768:{
                  slidesPerView:2.3,
                  spaceBetween:20,
                }
            },
        });
    });

    var swiper = new Swiper('.homedoctors_slidernw .swiper-container', {
          slidesPerView:3.4,
          lazy:true,
          loop:true,
          preloadImages:false,
          observer:true,
          observeParents:true,
          speed: 800,
          freeMode: true,
          freeModeSticky: false,
          mousewheel: {
            enabled: true,
            releaseOnEdges: true,
            forceToAxis: true,
            sensitivity:1, 
          },
          keyboard: {
            enabled: true,
          },
          spaceBetween:20,
          navigation: {
              nextEl: '.homedoctors_slidernw .swiper-button-next',
              prevEl: '.homedoctors_slidernw .swiper-button-prev',
          },
          breakpoints: {
              320: {
                slidesPerView:1.2,
                spaceBetween:15,
              },
              600:{
                slidesPerView:2.2,
                spaceBetween:15,
              },
              780: {
                slidesPerView:3.2,
                spaceBetween:20,
              },
              1100: {
                slidesPerView:3.4,
                spaceBetween:20,
              },
              1920: {
                slidesPerView:3.4,
                spaceBetween:20,
              },
          },
    });

    var swiper = new Swiper('.homeblog_slidernw .swiper-container', {
          slidesPerView:2.2,
          lazy:true,
          loop:true,
          preloadImages:false,
          observer:true,
          observeParents:true,
          speed: 800,
          freeMode: true,
          freeModeSticky: false,
          mousewheel: {
            enabled: true,
            releaseOnEdges: true,
            forceToAxis: true,
            sensitivity:1, 
          },
          keyboard: {
            enabled: true,
          },
          spaceBetween:20,
          navigation: {
              nextEl: '.homeblog_slidernw .swiper-button-next',
              prevEl: '.homeblog_slidernw .swiper-button-prev',
          },
          breakpoints: {
              320: {
                slidesPerView:1.2,
                spaceBetween:15,
              },
              600:{
                slidesPerView:2.2,
                spaceBetween:15,
              },
              780: {
                slidesPerView:2.2,
                spaceBetween:15,
              },
              1100: {
                slidesPerView:2.2,
                spaceBetween:20,
              },
          },
    });

    var swiper = new Swiper('.hometestimonials_slidernw .swiper-container', {
        slidesPerView:1.2,
        lazy: true,
        loop:true,
        preloadImages: false,
        observer: true,
        observeParents: true,
        speed: 800,
        freeMode: true,
        freeModeSticky: false,
        mousewheel: {
          enabled: true,
          releaseOnEdges: true,
          forceToAxis: true,
          sensitivity:1, 
        },
        keyboard: {
          enabled: true,
        },
        spaceBetween:20,
        navigation: {
            nextEl: '.hometestimonials_slidernw .swiper-button-next',
            prevEl: '.hometestimonials_slidernw .swiper-button-prev',
        },
        breakpoints: {
            320: {
              slidesPerView:1.1,
              spaceBetween:15,
            },
            600:{
              slidesPerView:1.2,
              spaceBetween:15,
            }
        },
    });

});